import crypto from 'crypto';

//      
// Range: n is a number between 0 and 1
// Will create an integer that mimics the range of n
var range = function range() {
  var lower = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var upper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return function (n) {
    return Math.floor(n * (upper - lower + 1)) + lower;
  };
};

// Create a random number between 0 and 1
var random = function random() {
  return crypto.randomBytes(4).readUInt32BE(0) / Math.pow(256, 4);
};

// Create a number hash between 0 and 1
var hash = function hash(s) {
  return crypto.createHash("sha256").update(s).digest().readUInt32BE(0) / Math.pow(256, 4);
};

var number = Object.freeze({
	range: range,
	random: random,
	hash: hash
});

//      
// Create a uuid
// RFC 4122 Version 4 compliant pattern
var from = function from(h) {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/x/g, function (v, i) {
    return h[i];
  }).replace(/y/g, function (v, i) {
    return range(8, 11)(parseInt(h[i], 16) / 16).toString(16);
  });
};

// Uuid regex
var pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

// Check if it is a uuid
var check = function check(uuid) {
  return pattern.test(uuid);
};

// Create a random uuid
var create = function create() {
  return from(crypto.randomBytes(18).toString("hex"));
};

// Create a uuid sha1 or sha256 hash
var hash$1 = function hash$$1(s, sha1Salt) {
  if (sha1Salt === undefined) {
    return crypto.createHash("sha256").update(s).digest("hex");
  }
  var buffer = Buffer.from(crypto.createHash("sha1").update("" + s + sha1Salt).digest("base64"), "base64");
  return buffer.toString("hex").toUpperCase();
};

var uuid = Object.freeze({
	check: check,
	create: create,
	hash: hash$1
});

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();

















































var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

//      


// Memoization for the compute function
var memoize = (function (compute) {
  // Keep track of the input
  var input = void 0;
  var output = void 0;

  // Return the memoized shape
  return function () {
    for (var _len = arguments.length, data = Array(_len), _key = 0; _key < _len; _key++) {
      data[_key] = arguments[_key];
    }

    // Check if something else changed
    if (input && input.length === data.length && input.every(function (v, k) {
      return v === data[k];
    })) {
      return output;
    }

    // Keep the last shape
    input = data;

    // Compute the output
    output = compute.apply(undefined, toConsumableArray(input));

    // Return the output
    return output;
  };
});

//

export { number, uuid, memoize };
